import React, { useEffect, useState } from 'react';

const COLORS = ['#e91e63', '#7c4dff', '#00c853', '#ff6d00', '#00bcd4', '#ffd600', '#ff4081'];

function createPetal(canvas) {
  const size = 6 + Math.random() * 8;
  const x = Math.random() * canvas.width;
  const y = -size;
  const speed = 1 + Math.random() * 2;
  const drift = (Math.random() - 0.5) * 1.5;
  const rotation = Math.random() * 360;
  const rotSpeed = (Math.random() - 0.5) * 4;
  const color = COLORS[Math.floor(Math.random() * COLORS.length)];
  const opacity = 0.6 + Math.random() * 0.4;
  return { x, y, size, speed, drift, rotation, rotSpeed, color, opacity };
}

export default function WelcomePage({ user, classCount, onDone }) {
  const canvasRef = React.useRef(null);
  const [show, setShow] = useState(true);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    const petals = Array.from({ length: 80 }, () => createPetal(canvas));
    let frame;

    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (const p of petals) {
        p.y += p.speed;
        p.x += p.drift + Math.sin(p.y * 0.02) * 0.5;
        p.rotation += p.rotSpeed;
        if (p.y > canvas.height + p.size) {
          Object.assign(p, createPetal(canvas));
          p.y = -p.size;
        }
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate((p.rotation * Math.PI) / 180);
        ctx.globalAlpha = p.opacity;
        ctx.fillStyle = p.color;
        ctx.beginPath();
        ctx.ellipse(0, 0, p.size * 0.6, p.size, 0, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }
      frame = requestAnimationFrame(animate);
    }
    animate();

    const timer = setTimeout(() => { setShow(false); if (onDone) onDone(); }, 4000);
    return () => { cancelAnimationFrame(frame); clearTimeout(timer); };
  }, []);

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #fce4ec 0%, #f3e5f5 50%, #e8f5e9 100%)',
    }}>
      <canvas ref={canvasRef} style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }} />

      <div style={{ position: 'relative', textAlign: 'center', padding: 20, animation: 'fadeInUp 0.6s ease-out' }}>
        <div style={{ fontSize: 64, marginBottom: 8 }}>🎉</div>
        <h2 style={{ fontSize: 26, color: '#e91e63', margin: '8px 0', fontWeight: 700 }}>
          欢迎加入{user.schoolName || '校友会'}！
        </h2>
        <p style={{ fontSize: 15, color: '#666', margin: '4px 0' }}>
          {user.className && <>你所在的 <strong>{user.className}</strong></>}
          {classCount > 0 && <> 已有 {classCount} 位同班同学</>}
        </p>
        <p style={{ fontSize: 13, color: '#999', marginTop: 12 }}>即将进入班级留言板...</p>
        <p style={{ fontSize: 12, color: '#ff9800', marginTop: 4 }}>
          {user.headTeacher ? '🛡️ 已填写班主任姓名，系统将自动验证同班身份' : '💡 建议填写班主任姓名以便同班同学互相认证'}
        </p>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}